import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const SellerLevel = ({level, isPro, isLimitedEdition, isNewSeller}) => {
    const sellerLevelProps = {
        className: 'gig-seller-tooltip'
    };

    let levelText = '';

    if (isLimitedEdition) {
        level = 'pro_spotlight_seller';
    }

    switch (level) {
        case 'level_one_seller':
        case 'level_two_seller':
        case 'pro_spotlight_seller':
            levelText = i18n.t(`seller_levels.${level}`);
            break;
        case 'top_rated_seller':
            levelText = i18n.t(`seller_levels.${level}`);
            levelText = <em>{levelText}</em>;
            break;
        default:
            if (isPro) {
                levelText = i18n.t('seller_levels.new_pro');
            } else if (isNewSeller) {
                levelText = i18n.t('seller_levels.new_seller');
            }

            break;
    }

    if (level) {
        sellerLevelProps.className += ' badge-hint js-badge-hint';
        sellerLevelProps['data-hint'] = i18n.t(`seller_levels.${level}_tooltip`);
    }

    return levelText ? <div {...sellerLevelProps}><span className="seller-level">{levelText}</span></div> : null;
};

SellerLevel.propTypes = {
    level: PropTypes.string,
    isPro: PropTypes.bool,
    isLimitedEdition: PropTypes.bool,
    isNewSeller: PropTypes.bool
};

export default SellerLevel;



// WEBPACK FOOTER //
// ./src/shared/seller_level/index.js